exports.module = require("wrong-module");
exports.file = require("./file");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/ignoring-module/index.js
 ** module id = 10
 ** module chunks = 0
 **/